import React, { useRef } from 'react';
import emailjs from 'emailjs-com';
import './Contact.css';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const Contact = () => {
    const toastId = useRef(null);


    const sendEmail = (e) => {
        e.preventDefault();

        emailjs.sendForm('service_200r93a', 'template_p0s2zut', e.target, 'user_hJSU6AMqoIqz90tZfOa1r')
        .then((result) => {
              console.log(result.text);
        }, (error) => {
              console.log(error.text);
        });

        toast.dismiss(toastId.current);
        toast.success("Successfully send!", {
            position: toast.POSITION.TOP_CENTER,
            autoClose: 3000
        });

        e.target.reset();
    }

    return (
        <>
            <div className="container mb-5" style={{ overflowX: 'hidden', overflowY: 'hidden' }}>
                <div className="contact-section">
                    <h1 className="text-center mb-1 pb-2">Get In Touch</h1>
                    <p className="mb-4 pb-4 text-center">I am always available. Feel free to contact me anytime.</p>
                    <div className="row mb-5" >
                        <div className="col-md-8 aos-init" data-aos="fade-right">
                            <h4 className="pb-2 pt-md-0 ">Message Me</h4>
                            <form onSubmit={sendEmail}>
                                <div className="row">
                                    <div className="col-12 col-md-6 form-group mb-4">
                                        <input type="name" className="form-control" name="name" placeholder="Full Name" required />
                                    </div>
                                    <div className="col-12 col-md-6 form-group mb-4">
                                        <input type="email" name="email" className="form-control" placeholder="Email" required />
                                    </div>
                                    <div className="col-12 form-group mb-4">
                                        <input type="text" name="subject" className="form-control" placeholder="Subject" required />
                                    </div>
                                    <div className="col-12 form-group">
                                        <textarea className="form-control" name="message" rows="5" placeholder="Message" required ></textarea>
                                    </div>
                                    <div className="col-8 col-sm-5 col-md-4 contact-btn">
                                        <button type="submit" className="btn btn-outline-custom px-3 mt-4  fw-bold text-white ms-3">Send Message</button>
                                    </div>
                                </div>
                            </form>
                        </div>
                        <div className="col-md-4" data-aos="fade-left">
                            <h4 className="pb-3 pt-md-0 pt-5 "> Contact Info</h4>
                            <h6 className="mb-4 pb-3 info-bottom">
                                Name:
                                <span className="fw-bold"> Muhammad Shahnewaz</span>
                            </h6>
                            <h6 className="mb-4 pb-3 info-bottom">
                                Location:
                                <span className="fw-bold"> Dhanmondi, Dhaka</span>
                            </h6>
                            <h6 className="mb-4 pb-3 info-bottom">
                                Contact Number:
                                <span className="fw-bold"> +8801782861044</span>
                            </h6>
                            <h6 className="mb-4 pb-3 info-bottom">
                                Email Me:
                                <span className="fw-bold"> shahnewaz601@gmail.com</span>
                            </h6>
                        </div>
                    </div>
                </div>
            </div>
            <ToastContainer />
        </>
    );
};


export default Contact;